import React from 'react';
import type { ButtonBlock as ButtonBlockType } from '../../../types';
import renderTextWithVariables from '../renderTextWithVariables';
import { useEditorContext } from '../EditorContext';

const ButtonBlock: React.FC<{ block: ButtonBlockType }> = ({ block }) => {
    const { canvas } = useEditorContext();
    return (
        <div style={{ margin: '0.8rem 0' }}>
            <span
                style={{
                    display: 'inline-block',
                    padding: '0.8rem 2rem',
                    backgroundColor: '#f26c3a',
                    color: '#fff',
                    borderRadius: '0.4rem',
                    fontWeight: 600,
                    textAlign: 'center',
                    ...(canvas && { fontSize: '1.4rem', lineHeight: 1.5 })
                }}
            >
                {renderTextWithVariables(block.text)}
            </span>
            {!canvas && (
                <span
                    style={{
                        display: 'block',
                        fontSize: '0.8em',
                        color: '#888',
                        marginTop: '0.2rem'
                    }}
                >
                    → {block.url}
                </span>
            )}
        </div>
    );
};
export default ButtonBlock;
